import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const ChevronDown = ({ size = 24 }: IconProps) => {
  const { theme } = useTheme();

  const fill = theme.icon.default;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00078 9.3748L7.07578 8.2998L12.0258 13.2498L16.9758 8.2998L18.0508 9.3748L12.0258 15.3998L6.00078 9.3748Z"
        fill={fill}
      />
    </svg>
  );
};
